<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="card-group mb-0">
						<div class="card p-4">
							<div v-if="!valid_activation">
								<div class="card-body">
									<h1>Activate Your account</h1>
								</div>
							</div>

							<div v-if="!valid_activation">
								<div class="card-body">
									<h1>Register</h1>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'

	export default {
		name: 'Account Activation',
		data() {
			return {
				form_data: {
					user_email: '',
					user_password: '',
					username: '',
					user_fullname: '',
				},
				invalid_register: false,
				valid_register: false,
				error_msg: '',
			}
		},
		methods: {
			register() {
				this.invalid_register = false
				this.valid_register = false
				this.$validator.validateAll().then((result) => {
					if (result) {
						// valid form
						axios.post('/user/register/', this.form_data).then((response) => {
							var record = response.data
							if (record.status == 0) {
								this.invalid_register = true
								this.error_msg = record.msg
							} else {
								this.valid_register = true
								//                            this.$router.push({ path: '/dashboard' })
							}
						})
					} else {
						// invalid
					}
				})
			},
		},
		created() {
			this.$root.loader = !true
		},
	}
</script>

